









































































































































































































































































































































































import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Component, Mixins, Vue } from 'vue-property-decorator';
import store from '@/services/store';
import CBudgetSumCalcProgTable from '@/modules/budget-request/components/budget-sum-calc/budget-sum-calc-prog-table.vue';
import CBudgetSumCalcProgGuTable from '@/modules/budget-request/components/budget-sum-calc/budget-sum-calc-prog-gu-table.vue';
import CBudgSumCalcGkkpMain from '@/modules/budget-request/components/budget-sum-calc/budget-gkkp-sum-calc-main.vue';
import CBubgUpload from '@/modules/budget-request/components/budget-sum-calc/budget-upload.vue';
import CBudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import { Ax } from '@/utils';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import { variantNameLangSupport } from '@/modules/budget/budgetCorrectHelper';
import { IBatchUpParams, startBatchUpload } from '@/modules/budget-request/components/js/budget-upload';
import BpI18nHandlerMixin from './mixins/bp-i18n-handler-mixin';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

@Component({
    components: {
        'c-calc-prog-tab': CBudgetSumCalcProgTable,
        'c-calc-prog-gu-tab': CBudgetSumCalcProgGuTable,
        'c-calc-gkkp-main': CBudgSumCalcGkkpMain,
        'c-budg-form-lst': CBudgetFormsList,
        'c-budg-upload': CBubgUpload
    },
    mixins: [BpI18nHandlerMixin]
})
export default class CBudgetSumCalcProg extends Vue {
    private error: any
    private budgetLevel: number[] = [];
    private urlFilter: any = null;
    // ---- тип фильтра  (0 - АБП/ГУ, 1 - ГККП)
    private uploadFilterType = 0; // для пакетной выгрузки
    private inAbpGuSection = 0; // 0 - В разрезе ГУ, 1 - В целом по АБП, 2- доп потребность
    private isConfirm = false; // false - без подтверждающих документов, true - с подтверждающими
    private isAdditionalNeed = false; // true - доп потребность
    private filterType = 0; // общий
    // --------------------

    private readonly moduleCodeAbp = '004.002.002.001'; // код свод АБП
    private readonly moduleCodeGu = '004.002.002.002'; // код свод ГУ
    private readonly moduleCodeGkkp = '004.002.002.003'; // код свод ГККП
    // ----
    private curYear = (new Date()).getFullYear();
    private periodLst: any[] = [];
    private curPeriod: any = null;

    private loadStatus = 1;
    private get loadStatusOprions() {
        const proc = this.getBudgetText('sum_calc_upload.processing'); // В процессе обработки
        const uploaded = this.getBudgetText('sum_calc_upload.uploaded'); // Выгруженные
        return [{ text: proc, value: 1 }, { text: uploaded, value: 2 }]
    }

    // доступность согласования
    private agrEnabled = false;
    private agrEnabledAccess = false; // доступность внутри вкладки по операциям пользователя

    private gkkpType = 1; // тип ГККП (0 - без учета платных; 1 - с учётом платных)

    private nameAllObj = { name_ru: 'Все', name_kk: 'Барлығы', name_en: 'All' }
    // --------------- доступность подписания ---------------------
    // --по версии бюджета (общее для всех вкладок)
    private signVariantEnable = false; // ЭЦП доступна только по актуальной не удалённой версии
    // --gu
    private guSignOperEnable = false; // доступность операции подписания
    private guUserSignEnable = false; // доступность подписания для пользователя
    private guCurUserSigned: boolean | null = null; // есть ли подпись для текущего пользователя
    // --abp
    private abpSignOperEnable = false; // доступность операции подписания
    private abpUserSignEnable = false; // доступность подписания для пользователя
    private abpCurUserSigned: boolean | null = null; // есть ли подпись для текущего пользователя
    // --------------------------------------

    // ---- доступность загрузки с Фаворита
    private favoriteEnabled = false;
    private impFavorit = false;
    private startLoad = false;

    private abpEnabled = false;
    private guEnabled = false;
    private gkkpEnabled = false;
    private loadTabEnabled =     false;
    //--------
    private tabIndxSelected = 0;
    // -----------
    private variantEndDate: any = null; // дата окончания вариантов, для ограничения справочников фильтров по датам
    // --------

    private get versYear() {
        if (!this.curDataType) { return null; }
        return (this.curDataType.code == '2' ? this.curVariant.year: null);
    }

    private getPeriodLst() {
        const year = (new Date()).getFullYear();
        this.periodLst = [];
        for (let i = year - 2020 + 1; i > 0; i--) {
            this.periodLst.push({ name: `${2020 + i} - ${2020 + i + 2}`, year: 2020 + i });
        }
        this.curPeriod = { name: `${year + 1} - ${year + 3}`, year: year + 1 };
        this.curYear = this.curPeriod.year;
    }
    // -----------
    private obl: string | null = null;
    // private region = '450101';

    private regionBase: any[] = [];
    private curRegion: any | null = null;

    private get getRegion() {
        const result: any[] = [];
        for (const el of this.regionBase) {
            result.push(setNameLang(this.$i18n.locale, el, 'code'));
        }
        if (this.curRegion !== null) { this.curRegion = setNameLang(this.$i18n.locale, this.curRegion, 'code'); }
        return result;
    }

    private async chgRegion() {
        await this.loadActiveVariant();
        this.loadVariants();
        // this.getBudgetLevel();
    }

    // ----

    private tabIndx = 0;

    private curFormSelect: any = '/budget-sum-calc-prog';

    private get usrId(): string | null {
        if (!store.state.user.sub) { return null; }
        return store.state.user.sub;
    }

    // ------------вид данных-----------
    private dataTypeDictBase: any[] = [];
    private curDataType: any | null = null;

    private get dataTypeDict(): any[] {
        const result: any[] = [];
        for (const el of this.dataTypeDictBase) {
            result.push(setNameLang(this.$i18n.locale, el, 'code'));
        }
        if (this.curDataType !== null) { this.curDataType = setNameLang(this.$i18n.locale, this.curDataType, 'code'); }
        return result;
    }

    // --------- гос учреждение ------------
    private guBase: any[] = [];
    private curGu: any | null = null;

    private get gu(): any[] {
        const result: any[] = [];
        let flAll = false; // есть ли Все гу
        for (const el of this.guBase) {
            if (el.code === null) { flAll = true; }
            if (el.code) {
                result.push(setNameLang(this.$i18n.locale, el, 'code'));
            } else {
                result.push(setNameLang(this.$i18n.locale, el));
            }
        }
        if (this.tabIndxSelected === 1 && !flAll && result.length > 0) { result.unshift(setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { code: null }))); }
        result.sort((a, b) => (a.code > b.code) ? 1 : -1);
        if (this.curGu !== null) {
            let code: string | null = null;
            if (this.curGu.code !== null) { code ='code' }
            this.curGu = setNameLang(this.$i18n.locale, this.curGu, code);
        }
        return result;
    }

    private chgGu() {
        if (this.tabIndxSelected === 1) { this.chgEvent('watch curGu'); }
        // this.loadAllTypePrg();
        this.loadAllTypeGkkpLst();
        if (!this.curGu || this.curGu.code!==null) {
            if (this.isAdditionalNeed) {
                this.inAbpGuSection = 2;
            } else {
                this.inAbpGuSection = 0;
            }
        }
    }
    // -------------- Подведомственные -----
    private subordBase: any[] = [];
    private curSubord: any | null = null;

    private get subordLst(): any[] {
        const result: any[] = [];
        let flAll = false;
        for (const el of this.subordBase) {
            if (el.code === null) { flAll = true; }
            if (el.code!==null) {
                result.push(setNameLang(this.$i18n.locale, el, 'code'));
            } else {
                result.push(setNameLang(this.$i18n.locale, el));
            }
        }
        if (this.tabIndxSelected === 1 && !flAll && result.length > 0) { result.unshift(setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { code: null }))); }
        if (this.curSubord !== null) {
            let code: string | null = null;
            if (this.curSubord.code !== null) { code ='code' }
            this.curSubord = setNameLang(this.$i18n.locale, this.curSubord, code);
        }
        return result;
    }

    private chgSubord() {
        if (this.tabIndxSelected === 0) { this.chgEvent('chgSubord'); }
        this.loadAllTypeGu();
    }

    // -------------- ГККП ---------------
    private gkkpBase: any[] = [];
    private curGkkp: any | null = Object.assign(this.nameAllObj, { bin: null });

    private get gkkpLst(): any[] {
        const result: any[] = [];
        for (const el of this.gkkpBase) {
            if (el.bin!==null) {
                result.push(setNameLang(this.$i18n.locale, el, 'bin'));
            } else {
                result.push(setNameLang(this.$i18n.locale, el));
            }
        }
        if (this.curGkkp !== null) {
            let code: string | null = null;
            if (this.curGkkp.bin !== null) { code ='bin' }
            this.curGkkp = setNameLang(this.$i18n.locale, this.curGkkp, code);
        }
        return result;
    }

    private async chgGkkp() {
        if (this.tabIndxSelected === 2) { this.chgEvent('chgGkkp curGkkp'); }
        await this.getDictGuForBudgetGkkp();
        this.fetchSpf();
        this.loadAllTypePrg();
    }

    // ------------Программа для загрузок -------------
    private prgBase: any[] = [];
    private curPrg: any = Object.assign(this.nameAllObj, { prg: null });

    private get prgLst(): any[] {
        const result: any[] = [];
        for (const el of this.prgBase) {
            if (el.prg !== null) {
                result.push(setNameLang(this.$i18n.locale, el, 'prg'));
            } else {
                result.push(setNameLang(this.$i18n.locale, el));
            }
        }
        if (this.curPrg !== null) {
            let code: string | null = null;
            if (this.curPrg.prg !== null) { code ='prg' }
            this.curPrg = setNameLang(this.$i18n.locale, this.curPrg, code);
        }
        return result;
    }

    // ------------------ администратор программ ------------------
    private abpBase: any[] = [];
    private abpGkkpBase: any[] = [];
    private curAbp: any | null = null;

    private get abp(): any[] {
        const res: any[] = [];
        for (const el of this.abpBase) {
            res.push(setNameLang(this.$i18n.locale, el, 'abp'));
        }

        if (this.curAbp !== null) { this.curAbp = setNameLang(this.$i18n.locale, this.curAbp, 'abp'); }
        return res;
    }

    private async chgAbp() {
        if (this.tabIndxSelected !== 2 && this.tabIndxSelected !== 1) { await this.chgEvent('watch chgAbp') };
        // this.loadAllTypeGkkpLst();
        this.loadAllTypeSubordinate();
        this.getFavoriteEnabled();
        await this.getDictGuForBudgetGkkp();
        this.fetchSpf();
    }

    // ------------- версия бюджета
    private curVariant: null | any = null;
    private variantBase: any[] = [];

    private get variantLst(): any[] {
        const res: any[] = [];
        for (const el of this.variantBase) {
            const tmpObj = setNameLang(this.$i18n.locale, el);
            res.push(tmpObj);
        }
        if (this.curVariant !== null) { this.curVariant = setNameLang(this.$i18n.locale, this.curVariant); }
        return res;
    }

    private appendixNumbers: {[key: string]: number | null} = {
        '02-159': null,      // Приложение 55 (старое 49)
        'Form_GU_svod': null,  // Приложение 75 (старое 58)
        '01-311_svod': null    // Приложение 83 (старое 67)
    };

    private async loadAppendixNumbers() {
        if (!this.curPeriod || !this.curPeriod.year) return;

        const curYear = this.curPeriod.year;
        const formCodes = ['02-159', 'Form_GU_svod', '01-311_svod'];

        for (const code of formCodes) {
            try {
                const response = await fetch(`/api-py/get-number-report/${code}/${curYear}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                this.appendixNumbers[code] = data;
            } catch (error) {
                console.error(`Error loading appendix number for ${code}:`, error);
                this.appendixNumbers[code] = null;
            }
        }
    }

    private chgEvent(source: string) {
        const curSubord = this.curSubord? this.curSubord.code:  '-1';
        const params = { curYear: this.curYear, curAbp: this.curAbp, curDataType: this.curDataType, regionProp: this.curRegion, curVariant: this.curVariant, curGu: this.curGu? this.curGu: {code: '-1'}, curGkkp: this.curGkkp ? this.curGkkp : {bin: '-1'}, variantEndDate: this.variantEndDate, gkkpType: this.gkkpType, curSubord: curSubord };
        if (this.tabIndxSelected === 0) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refAbp.chgEvent(params);
        } else if (this.tabIndxSelected === 1) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refGu.chgEvent(params);
        } else if (this.tabIndxSelected === 2) {
            if (this.$refs.refGkkp) {
                // eslint-disable-next-line
                // @ts-ignore
                this.$refs.refGkkp.chgEvent(params);
            }
        }
    }

    private startImportFavorit() {
        this.$bvModal.msgBoxConfirm(this.otherTitle.confirm_favorit,
            {
            title: this.otherTitle.confirm,
            size: 'lg',
            buttonSize: 'sm',
            okVariant: 'success',
            okTitle: this.otherTitle.conf_yes,
            cancelTitle: this.otherTitle.conf_no,
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
            if (value) { this.importFavorit(false); }
        })
    }

    private async importFavorit(favoritDataTypeAgree?: boolean) {
        if (this.curAbp.abp !== 261) { return; }
        const params = { abp: this.curAbp.abp, curYear: this.curYear, region: this.curRegion.code, variant: this.curVariant.variant_uuid, data_type: this.curDataType.code, favorit_data_type_agree: favoritDataTypeAgree }
        this.startLoad = true;
        try {
            const result: any = await fetch(`/api-py/load-favorit-to-total/${encodeURI(JSON.stringify(params))}`);
            if (result.status === 200) {
                const json = await result.json();
                if (json.status === 'success') {
                    let txt = `Загружено ${json.countRow} записей на сумму ${Math.round(json.sumRow).toLocaleString("ru-RU")}`;
                    if (this.$i18n.locale == 'kk') {
                        txt = `${Math.round(json.sumRow).toLocaleString("ru-RU")} сомасына ${json.countRow} жазба жүктелді`;
                    } else if (this.$i18n.locale == 'en') {
                        txt = `Uploaded ${json.countRow} records worth ${Math.round(json.sumRow).toLocaleString("ru-RU")}`;
                    }
                    makeToast(this, 'success', 'Фаворит', txt);
                } else if (json.status === 'error') {
                    if (json.error && json.error == 'data_type') {
                        this.$bvModal.msgBoxConfirm(`${this.otherTitle.importFavorit[0]} (${json.favorit_data_type} - ${json.favorit_data_name}) ${this.otherTitle.importFavorit[1]}`,
                        {
                        title: this.otherTitle.confirm,
                        size: 'lg',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        okTitle: this.otherTitle.conf_yes,
                        cancelTitle: this.otherTitle.conf_no,
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                        })
                        .then(value => {
                        if (value) {
                            this.importFavorit(true);
                            this.startLoad = false;
                            return;
                        }
                        })
                    } else {
                        makeToast(this, 'danger', 'load-favorit-to-total', `${json.data} - ${json.errTxt}`);
                        console.error('load-favorit-to-total', json.errTxt);
                    }
                    return;
                }
            } else {
                makeToast(this, 'danger', 'load-favorit-to-total', `${result.status} - ${result.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка запроса load-favorit-to-total', (error as Error).toString());
        } finally {
            this.startLoad = false;
        }
        this.chgEvent('importFavorit');
    }

    // ---- операцию свода абп по загрузке фаворита
    private async getImpFavorit() {
        this.impFavorit = false;
        if (!this.usrId || !this.abpEnabled) { return; }
        let result = null;
        try {
            result = await fetch(encodeURI(`/api/um/module/link?user=${this.usrId}&modulecode=${this.moduleCodeAbp}`));
            if (result.status === 200) {
                result = await result.json();
            } else {
                if (result.status !== 404) { makeToast(this, 'danger', 'Ошибка get-realm-user', `${result.status}  ${result.statusText}`); }
                return;
            }
            if (result && result.operations) {
                for (const el of result.operations) {
                    if (el === 'imp_favorit') {
                        this.impFavorit = true;
                        return;
                    }
                }
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-realm-user ' + this.usrId, (error as Error).toString());
            return;
        }
    }

    // ------------------
    private getModulesAccess() {
        let access = this.getAccess(this.moduleCodeGu);
        this.guEnabled = access.enable;
        // --
        access = this.getAccess(this.moduleCodeAbp);
        this.abpEnabled = access.enable;
        // --
        access = this.getAccess(this.moduleCodeGkkp);
        this.gkkpEnabled = access.enable;
        // --
        access = this.getAccess('004.002.002.004');
        this.loadTabEnabled = access.enable;
        this.getTabIndx();
        if (!this.abpEnabled && !this.guEnabled) {
            this.uploadFilterType = 1;
            // if (this.inAbpGuSection===2){
            //     this.isAdditionalNeed=true
            // }
        } else {
            this.uploadFilterType = 0;
            // if (this.isAdditionalNeed) {
            //     this.inAbpGuSection=2
            // }
        }
        this.getImpFavorit();
    }

    private getAccess(code: string) {
        const modules: any[] = store.state.user.userModules;
        let editable = false;
        let enable = false;
        for (const row of modules) {
            if (row.modules === code) {
                if (row.access_level !== 1) {
                    editable = true;
                }
                if ([1, 2, 3].includes(row.access_level)) {
                    enable = true;
                }
            }
        }
        return { editable, enable };
    }

    // ----------------

    private mounted() {
        this.getModulesAccess();
        this.loadDataTypeDict();
        this.getImpFavorit();
        this.getPeriodLst();
        this.getObl();
        this.loadVariants();
        // eslint-disable-next-line
        const that = this;

        this.$watch('usrId', () => {
            if (!this.usrId) { return; }
            this.getImpFavorit();
            this.getObl();
            this.loadVariants();
        })

        this.$watch('curPeriod', async () => {
            if (this.curPeriod) {
                this.curYear = this.curPeriod.year;
                await this.loadActiveVariant();
                this.loadVariants();
                await this.loadAppendixNumbers();
            }
        }, { immediate: true });
        /* this.$watch('curDataType', () => {
            this.loadVariants();
        });*/
        /* this.$watch('curVariant', async () => {
            this.agrEnabled = false;
            this.getFavoriteEnabled();
            await this.getVariantEndDate();
            if (this.curVariant && this.curVariant.attribute && !this.curVariant.status) {
                this.agrEnabled = true;
            }
            this.chgEvent('watch curVariant');
        }); */
        this.$watch('tabIndx', () => { this.getTabIndx(); });
        // при смене вкладки согласование недоступно, пока новая вкладка не загрузит операции пользователя
        this.$watch('tabIndxSelected', () => { this.agrEnabledAccess = false; });
        this.$watch('store.state.user.userModules', () => { this.getModulesAccess(); });
        this.$watch('gkkpType', () => {
            if (this.tabIndxSelected === 2) { this.chgEvent('watch gkkpType'); }
        });
        this.$watch('uploadFilterType', () => {
            this.chgFilterType();
        });
        this.timerId = window.setInterval(() => {
            this.$forceUpdate();
        }, 60000);
    }


    private async chgCurVariant() {
        this.agrEnabled = false;
        this.getFavoriteEnabled();
        this.getSignVariantEnable(); // синхронно, до await: иначе флаг отстаёт от выбранной версии
        await this.getVariantEndDate();
        if (this.curVariant && this.curVariant.attribute && !this.curVariant.status) {
            this.agrEnabled = true;
        }
        this.getBudgetLevel()
        // this.chgEvent('watch curVariant');
    }

    /**
     * получение variantStartDate для ограничение действия справочников в фильтрах
     */
    private async getVariantEndDate() {
        if (!this.curVariant) {
            this.variantEndDate = null;
            return;
        }
        if (this.curVariant.date_ueb) {
            this.variantEndDate = this.curVariant.date_ueb;
            return;
        }
        if (this.curVariant.attribute === true && this.curVariant.status === false && !this.curVariant.is_deleted) {
            this.variantEndDate = null;
            return;
        }

        let response: any = [];
        try {
            response = await fetch(`/api-py/get-next-variant-date-start/${encodeURI(this.curVariant.date_start)}`);
            if (response.status === 200) {
                response = await response.json();
                this.variantEndDate = response.date;
            } else {
                this.variantEndDate = null;
                makeToast(this, 'danger', 'Ошибка get-next-variant-date-start', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            this.variantEndDate = null;
            makeToast(this, 'danger', 'Ошибка get-next-variant-date-start', (error as Error).toString());
        }
    }


    private chgDataType() {
        this.loadVariants();
    }

    private getFavoriteEnabled() {
        this.favoriteEnabled = false;
        if (this.curVariant && this.curVariant.attribute && this.impFavorit && this.curAbp && this.curAbp.abp === 261) { this.favoriteEnabled = true; }
    }

    /**
     * подписание ЭЦП доступно только для актуальной не удалённой версии бюджета
     */
    private getSignVariantEnable() {
        this.signVariantEnable = !!(this.curVariant && this.curVariant.attribute === true && !this.curVariant.is_deleted);
    }

    // ----- закгрузка активного варианта
    private async loadActiveVariant() {
        if (!this.curYear || !this.curRegion) { return; }
        const params = { year: this.curYear, region: this.curRegion.code };
        const url = `/api-py/get--active-variants-for-calcsum/${encodeURI(JSON.stringify(params))}`;
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
                if (response.length) {
                    for (let i = 0; i < this.dataTypeDict.length; i++) {
                        if (response[0].data_type.toString() === this.dataTypeDict[i].code) {
                            this.curDataType = this.dataTypeDict[i];
                            break;
                        }
                    }
                }
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки активных вариантов', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки активных вариантов', (error as Error).toString());
        }
    }

    // -------------------- load
    private async loadVariants() {
        this.variantBase = [];
        if (!this.curYear || !this.curDataType || !this.curRegion || !this.usrId) { return; }
        // await this.loadActiveVariant();
        const params = { year: this.curYear, dataType: this.curDataType.code, region: this.curRegion.code };
        const url = `/api-py/get-variants-for-calcsum/${encodeURI(JSON.stringify(params))}`;
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
                for (const el of response) {
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    el.name_ru = variantNameLangSupport(el, 'ru');
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    el.name_kk = variantNameLangSupport(el, 'kk');
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    el.name_en = variantNameLangSupport(el, 'en');
                }
                this.variantBase = response;
                if (this.variantBase.length) {
                    const tmpObj = this.getFirstActiveVariant();
                    if (!this.curVariant || this.curVariant.variant_uuid!== tmpObj.variant_uuid) {
                        const flNull = (this.curVariant === null);
                        this.curVariant = tmpObj;
                        // if (flNull) { this.chgEvent('loadVariants'); }
                    }
                } else {
                    this.curVariant = null;
                }
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки вариантов', `${response.status} - ${response.statusText}`);
                this.curVariant = null;
                // this.chgEvent('loadVariants');
            }
        } catch (error) {
            this.curVariant = null;
            // this.chgEvent('loadVariants');
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки вариантов', (error as Error).toString());
        } finally {
            this.chgCurVariant();
        }
    }

    private getFirstActiveVariant() { // получить первый активный вариант или утверждённый
        let utv: any | null = null; // утверждённый
        let max: any | null = null; // макс id
        for (let i = 0; i < this.variantBase.length; i++) {
            const el = this.variantBase[i];
            if (el.attribute) { return setNameLang(this.$i18n.locale, el); }
            if (max === null) {
                max = el;
            } else if (max.id<el.id) {
                max = el;
            }
            if (el.status) {
                if (utv === null) {
                    utv = el;
                } else {
                    if (el.date_ueb === null  || utv.date_ueb === null) {
                        if (el.id > utv.id)  { utv = el; }
                    } else if (new Date(el.date_ueb) > new Date(utv.date_ueb)){
                        utv = el;
                    }
                }
            }
        }
        if (utv) { return setNameLang(this.$i18n.locale, utv); }
        return max? setNameLang(this.$i18n.locale, max): null;
    }

    /* private async loadBudgetLevel() {
        if (this.budgetLevel.length > 0) { return; }
        this.budgetLevel = [];

        if (!this.usrId) { return; }
        let result = [];
        try {
            result = await fetch(encodeURI('/api-py/get-user-budget-level/' + this.usrId)).then(response => response.json());
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки уровня бюджета', (error as Error).toString());
            return;
        }
        if (!Array.isArray(result)) { return; }
        for (const el of result) {
            // eslint-disable-next-line @typescript-eslint/camelcase
            const indx = el.budget_level.lastIndexOf('_');
            if (indx >= 0) {
                this.budgetLevel.push(parseInt(el.budget_level.substr(indx + 1)));
            }
        }
        if (this.budgetLevel.length === 0) { makeToast(this, 'warning', 'Внимание!', 'Нет доступных уровней бюджета у пользователя!'); }

        this.loadAbp();
    } */

    private getBudgetLevel() {
        this.budgetLevel = [];
        if (this.curRegion) {
            if (this.curRegion.code.slice(this.curRegion.code.length - 4) === '0101') {
                this.budgetLevel.push(2);
            } else if (this.curRegion.code.slice(this.curRegion.code.length - 2) === '01')  {
                this.budgetLevel.push(3);
            } else if (this.curRegion.code.slice(this.curRegion.code.length - 2) !== '00') {
                this.budgetLevel.push(4);
            }
        }
        this.abpBase = [];
        this.loadAllTypeAbp();
    }

    private loadAllTypeAbp() {
        if (!this.curVariant || !this.budgetLevel || this.budgetLevel.length < 1) {
            this.curAbp = null;
            this.chgAbp();
            return;
        }
        const vers_year = (this.curDataType.code == '2' ? this.curVariant.year: null);
        const params = { region: this.curRegion.code, usrId: this.usrId, date_b: this.curVariant.date_start, date_e: this.variantEndDate, vers_year: vers_year, level: this.budgetLevel };
        let url = `/api-py/get-dict-abp-by-level-user-region-dateend/${encodeURI(JSON.stringify(params))}`
        if (this.filterType !== 0) {
            url = `/api-py/get-budget-abp-for-gkkp/${encodeURI(JSON.stringify(params))}`;
        }
        this.loadAbp(url);
    }

    private async loadAbp(url: string) {
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки адм. программ', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            makeToast(this, 'danger', 'Ошибка загрузки адм. программ', (error as Error).toString());
        }

        response.sort((a: any, b: any) => (a.abp - b.abp > 0) ? 1 : -1);
        this.abpBase = this.setIdArr(response, 'abp');

        if (this.abpBase.length > 0) {
            if (this.urlFilter && this.urlFilter.abp) {
                this.curAbp = this.findElByCode('abp', this.urlFilter.abp, this.abpBase);
                this.urlFilter.abp = null;
            } else {
                let abp: any = null;
                if (this.curAbp) {
                    abp = this.findElByCode('abp', this.curAbp.abp, this.abpBase);
                }

                this.curAbp = abp !== null ? abp:  this.abpBase[0];
            }
        } else {
            this.curAbp = null;
        }
        this.chgAbp();
    }

    private getUrl() {
        // eslint-disable-next-line require-unicode-regexp
        if (window.location.href.match(/.*\?.*/)) {
            // eslint-disable-next-line require-unicode-regexp
            const tmp = decodeURIComponent(window.location.href.replace(/.*\?/, '')).split('&');
            for (const p of tmp) {
                const tmp2 = p.split('=');
                if (tmp2[0] === 'filter') {
                    this.urlFilter = JSON.parse(tmp2[1]);
                }
            }
        }
        if (this.urlFilter && this.urlFilter.year) { this.curYear = this.urlFilter.year; }
    }

    private async getObl() {
        try {
            const result = await fetch('/api-py/get-budget-obl/' + store.state._instanceCode);
            if (result.status === 200) {
                const json = await result.json();
                this.obl = json.obl;
            } else {
                makeToast(this, 'danger', 'get-budget-obl', `${result.status} - ${result.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка запроса get-budget-obl', (error as Error).toString());
        }

        if (!this.usrId) { return; }

        try {
            await fetch('/api-py/get-user-regions-by-obl/' + this.obl + '/' + this.usrId)
                .then(response => response.json())
                .then(json => {
                    if (json.length && json[0].code) {
                        json.sort((a: any, b: any) => (a.code - b.code > 0) ? 1 : -1);
                        this.regionBase = json;
                    }

                });
        } catch (error) {
            this.regionBase = [];
            makeToast(this, 'danger', 'Ошибка запроса get-user-budget-region', (error as Error).toString());
        }
        if (this.regionBase.length) {
            this.curRegion = setNameLang(this.$i18n.locale, this.regionBase[0], 'code')
        } else {
            this.curRegion = null;
        }
        this.chgRegion();
        // if (this.region === region) { return; }
        // this.region = region;
        // this.loadVariants();
    }

    private async loadDataTypeDict() {
        let result: any[] = [];
        try {
            result = await fetch('/api-py/dict_budget_data_types/')
                .then(response => response.json());
        } catch (error) {
            result = [];
            makeToast(this, 'danger', 'Ошибка загрузки вида данных', (error as Error).toString());
        }
        result.sort((a, b) => (a.code > b.code) ? 1 : -1);
        this.dataTypeDictBase = result;
        if (this.dataTypeDictBase.length > 0) {
            let el = null;
            if (this.urlFilter && this.urlFilter.dataType) {
                el = this.findElByCode('code', this.urlFilter.dataType, this.dataTypeDictBase);
                this.urlFilter.dataType = null;
            } else {
                el = this.dataTypeDictBase[0];
            }
            this.curDataType = setNameLang(this.$i18n.locale, el, 'code');
        }
    }

    private spfBase: any[] = [];
    private dictGuBase: any[] = [];
    private curDictGu: any[] = [];

    //private get getSpf() {
    //    const result: any[] = [];
    //    for (const el of this.spfBase) {
    //        result.push(setNameLang(this.$i18n.locale, el, 'code'));
    //    }
    //    if (this.curSpf !== null && !this.curSpf.name) { this.curSpf = setNameLang(this.$i18n.locale, this.curSpf, 'code'); }
    //    return result;
    //}

    private async getDictGuForBudgetGkkp() {
        if (!this.curAbp || !this.curRegion || !this.usrId || !this.curVariant) {
            this.dictGuBase = [];
            this.curDictGu = [];
            return;
        }
        let result: any[] = [];
        try {
            const params = { abp: this.curAbp.abp, userId: this.usrId, region: this.curRegion.code, date_b: this.curVariant.date_start, date_e: this.variantEndDate }
            result = await fetch(`/api-py/get-dict-gu-for-budget-gkkp/${encodeURI(JSON.stringify(params))}`)
                .then(response => response.json());
        } catch (error) {
            result = [];
            makeToast(this, 'danger', 'Ошибка загрузки ГУ', (error as Error).toString());
        }
        if (result.length > 0) {
            result.sort((a, b) => (a.code > b.code) ? 1 : -1);
            this.dictGuBase = result;
            for (const gu of this.dictGuBase) {
                if (!this.curDictGu.includes(gu.code)) {
                    this.curDictGu.push(gu.code);
                }
            }
        }
    }

    private async fetchSpf() {
        if (!this.curVariant || !this.curAbp || !this.curRegion || !this.usrId || !this.curGkkp) {
            this.spfBase = [];
            return;
        }
        let result: any = [];
        try {
            const params = JSON.stringify({
                userId: this.usrId,
                abp: this.curAbp.abp,
                region: this.curRegion.code,
                gkkp: this.curGkkp,
                locale: this.$i18n.locale
            });
            result = await fetch(`/api-py/get-spf-by-gkkp-user-abp-region-date-e-b/${encodeURI(params)}`)
                .then(response => response.json());
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка определения СПФ', (error as Error).toString());
        }
        this.spfBase = result;
    }

    private isSpf159(){
        let flag = false;
        for (const spf of this.spfBase) {
            if (spf == 159) {
                flag = true;
            }
        }
        return flag;
    }

    private isSpf311(){
        let flag = false;
        for (const spf of this.spfBase) {
            if (spf == 311) {
                flag = true;
            }
        }
        return flag;
    }

    private setIdArr(arr: any[], codeName: string) {
        const result: any[] = [];
        for (const el of arr) {
            if (result.length > 0 && el[codeName] === result[result.length - 1][codeName]) {
                result[result.length - 1].idArr.push(el.id);
            } else {
                result.push(Object.assign({ idArr: [el.id] }, el));
            }
        }
        return result;
    }

    private findElByCode(codeName: string, code: any, arr: any[]): any {
        for (const el of arr) {
            if (el[codeName] === code) {
                return el;
            }
        }
        return null;
    }

    private openFilterByRef(refName: string) {
        const drop: any = this.$refs.drop;
        drop.show(true);
        const refItem: any = this.$refs[refName];
        setTimeout(() => refItem.$el.focus(), 100);
    }

    private loadReportOfSummaryOfCalculationAbp() {
        const params = JSON.stringify({ curYear: parseInt(this.curYear.toString()), abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, curVariant: this.curVariant.variant_uuid, date_b: this.curVariant.date_start, date_e: this.variantEndDate, locale: this.$i18n.locale });
        const urls = '/api-py/get-budget-sum-calc-abp/'+encodeURI(params);
        Ax<Blob>(
            {
                url: urls,
                method: 'POST',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Сводный расчет расходов АБП.xls');// or any other extension
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                this.error = error;
            }
        );
    }

    private loadReportOfSummaryOfCalculationAbpGkkp() {
        const params = JSON.stringify({ curYear: parseInt(this.curYear.toString()), abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, curVariant: this.curVariant.variant_uuid, date_b: this.curVariant.date_start, date_e: this.variantEndDate, locale: this.$i18n.locale });
        const urls = '/api-py/get-budget-sum-calc-abp-gkkp/'+encodeURI(params);
        Ax<Blob>(
            {
                url: urls,
                method: 'POST',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Сводный расчет расходов АБП в т.ч. ГККП.xls');// or any other extension
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                this.error = error;
            }
        );
    }

    private get isReportSumCalcGuAvailable(): boolean {
        return !!(this.curAbp && Number(this.curAbp.abp) === 261 && this.curSubord && this.curSubord.code);
    }

    private uploadReportSumCalcGu() {
        if (!this.isReportSumCalcGuAvailable) { return; }
        const params = `year=${this.curYear}&region=${this.curRegion.code}&variant=${this.curVariant.variant_uuid}&abp=${this.curAbp.abp}&gu-parent=${this.curSubord.code}&locale=${this.$i18n.locale}`;
        const urls = '/api/excel/consolidated-report-abp?'+encodeURI(params);
        Ax<Blob>(
            {
                url: urls,
                method: 'GET',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Сводный расчет расходов ${this.curAbp.abp} АБП по подведомственным ГУ.xlsx`);// or any other extension
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                this.error = error;
            }
        );
    }

    private loadReportOfSummaryOfCalculation() {
        const params = JSON.stringify({ curYear: parseInt(this.curYear.toString()), abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, curVariant: this.curVariant.variant_uuid, userId: this.usrId, date_b: this.curVariant.date_start, date_e: this.variantEndDate, locale: this.$i18n.locale, curGu: this.curGu ? this.curGu.code : null });
        const urls = '/api-py/get-budget-sum-calc-abp-gu/'+encodeURI(params);
        Ax<Blob>(
            {
                url: urls,
                method: 'POST',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Сводный расчет расходов АБП по ГУ.xls');// or any other extension
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                this.error = error;
            }
        );
    }

    private loadReportSumGkkp() {
        this.isDownloadButtonEnabled = true;
        const params = JSON.stringify({ uid: this.usrId, curYear: parseInt(this.curYear.toString()), abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, curVariant: this.curVariant.variant_uuid, date_b: this.curVariant.date_start, date_e: this.variantEndDate, gkkp: this.curGkkp? this.curGkkp.bin: null, locale: this.$i18n.locale });
        const urls = '/api-py/budg_sum_gkkp_reports/' + encodeURI(params);
        Ax<Blob>(
            {
                url: urls,
                method: 'POST',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Свод ГККП (без учета платных).xls');// or any other extension
                document.body.appendChild(link);
                link.click();
                this.isDownloadButtonEnabled = false;
            },
            (error) => {
                this.error = error;
                this.isDownloadButtonEnabled = false;
            }
        );
    }

    private loadReportSumGkkpPaid() {
        this.isDownloadButtonEnabled = true;
        const params = JSON.stringify({ uid: this.usrId, curYear: parseInt(this.curYear.toString()), abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, curVariant: this.curVariant.variant_uuid, date_b: this.curVariant.date_start, date_e: this.variantEndDate, gkkp: this.curGkkp.bin, locale: this.$i18n.locale });
        const urls = '/api-py/budg_sum_gkkp_reports_paid/' + encodeURI(params);
        Ax<Blob>(
            {
                url: urls,
                method: 'POST',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Свод ГККП (с учетом платных).xls');// or any other extension
                document.body.appendChild(link);
                link.click();
                this.isDownloadButtonEnabled = false;
            },
            (error) => {
                this.error = error;
                this.isDownloadButtonEnabled = false;
            }
        );
    }

    private loadReportSumCalcGkkp() {
        let params = `year=${parseInt(this.curYear.toString())}&abp=${this.curAbp.abp}&region=${this.curRegion.code}&variant=${this.curVariant.variant_uuid}`;
        if (this.curGkkp && this.curGkkp.bin) { params += `&bin=${this.curGkkp.bin}`; }
        const urls = '/api/excel/consolidated-report?'+encodeURI(params);
        Ax<Blob>(
            {
                url: urls,
                method: 'GET',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Сводный расчет расходов по ГККП.xlsx');
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                this.error = error;
            }
        );
    }

    //private getCommonText!: any;

    private loadApp49ReportSumGkkp() {
        this.isDownloadButtonEnabled = true;
        const params = JSON.stringify({ uid: this.usrId, cur_year: parseInt(this.curYear.toString()), abp: this.curAbp.abp, data_type: this.curDataType.code, region: this.curRegion.code, gu: this.curDictGu, variant: this.curVariant.variant_uuid, date_b: this.curVariant.date_start, date_e: this.variantEndDate, gkkp: this.curGkkp, locale: this.$i18n.locale });
        const urls = '/api-py/budg_sum_gkkp_app_02_159/' + encodeURI(params);
        Ax<Blob>(
            {
                url: urls,
                method: 'POST',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                const fileName = this.dynamicAppendixTitles.app49;
                link.href = url;
                link.setAttribute('download', `${fileName}.xls`);// or any other extension
                document.body.appendChild(link);
                link.click();
                this.isDownloadButtonEnabled = false;
            },
            (error) => {
                this.error = error;
                this.isDownloadButtonEnabled = false;
            }
        );
    }

    private loadApp58ReportSumGkkp() {
        this.isDownloadButtonEnabled = true;
        const params = JSON.stringify({ uid: this.usrId, cur_year: parseInt(this.curYear.toString()), abp: this.curAbp.abp, data_type: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, date_b: this.curVariant.date_start, date_e: this.variantEndDate, gkkp: this.curGkkp, locale: this.$i18n.locale });
        const urls = '/api-py/budg_sum_gkkp_app_form_gu_svod/' + encodeURI(params);
        Ax<Blob>(
            {
                url: urls,
                method: 'POST',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                const fileName = this.dynamicAppendixTitles.app58;
                link.href = url;
                link.setAttribute('download', `${fileName}.xls`);// or any other extension
                document.body.appendChild(link);
                link.click();
                this.isDownloadButtonEnabled = false;
            },
            (error) => {
                this.error = error;
                this.isDownloadButtonEnabled = false;
            }
        );
    }

    private loadApp67ReportSumGkkp() {
        this.isDownloadButtonEnabled = true;
        const params = JSON.stringify({ uid: this.usrId, cur_year: parseInt(this.curYear.toString()), abp: this.curAbp.abp, data_type: this.curDataType.code, region: this.curRegion.code, gu: this.curDictGu, variant: this.curVariant.variant_uuid, date_b: this.curVariant.date_start, date_e: this.variantEndDate, gkkp: this.curGkkp, locale: this.$i18n.locale });
        const urls = '/api-py/budg_sum_gkkp_app_01_311_svod/' + encodeURI(params);
        Ax<Blob>(
            {
                url: urls,
                method: 'POST',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                const fileName = this.dynamicAppendixTitles.app67;
                link.href = url;
                link.setAttribute('download', `${fileName}.xls`);// or any other extension
                document.body.appendChild(link);
                link.click();
                this.isDownloadButtonEnabled = false;
            },
            (error) => {
                this.error = error;
                this.isDownloadButtonEnabled = false;
            }
        );
    }

    private isDownloadButtonEnabled = false;

    private loadBatchReportOfSummaryOfCalculation() {
        this.isDownloadButtonEnabled = true;
        const params = JSON.stringify({ curYear: parseInt(this.curYear.toString()), abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, curVariant: this.curVariant.variant_uuid, date_b: this.curVariant.date_start, date_e: this.variantEndDate, locale: this.$i18n.locale });
        const urls = '/api-py/get-budget-sum-calc-abp-batch-reports/' + encodeURI(params);
        Ax<Blob>(
            {
                url: urls,
                method: 'POST',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Пакетная выгрузка свод по АБП.xls');// or any other extension
                document.body.appendChild(link);
                link.click();
                this.isDownloadButtonEnabled = false;
            },
            (error) => {
                this.error = error;
                this.isDownloadButtonEnabled = false;
            }
        );
    }

    private agreementEvent() {
        if (this.tabIndxSelected === 0) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refAbp.agreementEvent();
        }
        if (this.tabIndxSelected === 1) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refGu.agreementEvent();
        }
        if (this.tabIndxSelected === 2) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refGkkp.agreementEvent();
        }
    }

    private infoCostForm(info_id: any) {
        const that = this;
        Ax<Blob>(
            {
                url: '/api-py/get-info/' + info_id, //  Тело файла
                method: 'POST',
                data: null,
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                let file = '';
                if (info_id == 23) {
                    file = 'Инструкция Свод по АБП';
                }
                link.setAttribute('download', file + '.pdf');// or any other extension
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                that.error = error;
            }
        );
    }

    private loadAllTypeGkkpLst() {
        this.gkkpBase = [];
        this.curGkkp = null;
        if (!this.curVariant || !this.curAbp || !this.curRegion || !this.usrId) {
            this.gkkpBase = [];
            if ((this.filterType !== 0 && this.tabIndxSelected === 3) || this.tabIndxSelected === 2) {
                this.curGkkp = null;
            } else {
                this.curGkkp = setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { bin: null }));
            }

            this.chgGkkp();
            return;
        }
        let gu = this.curGu? this.curGu.code: '-1';
        if (this.tabIndxSelected === 2) { gu = null; }
        const subord = this.curSubord? this.curSubord.code: '-1';
        const params = { abp: this.curAbp.abp, userId: this.usrId, region: this.curRegion.code, date_b: this.curVariant.date_start, date_e: this.variantEndDate, vers_year: this.versYear, abpEnabled: this.abpEnabled, guEnabled: this.guEnabled, gkkpEnabled: this.gkkpEnabled, gu: gu, subord: subord };
        let all = true;
        let url = `/api-py/dict-kgkp-by-region-abp-userid-year/${encodeURI(JSON.stringify(params))}`;
        if ((this.filterType !== 0 && this.tabIndxSelected === 3) || this.tabIndxSelected === 2) {
            url = `/api-py/get-budget-upload-gkkp/${encodeURI(JSON.stringify(params))}`;
            all = false;
        }
        this.loadGkkpLst(url, all);
    }

    private async loadGkkpLst(url: string, all: boolean) {
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки ГККП', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки ГККП', (error as Error).toString());
        }
        if (response.length) { response.sort((a: any, b: any) => (a.bin > b.bin) ? 1 : -1); }
        if (all) { response.unshift(setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { bin: null }))); }
        if (response.length > 0) {
            this.curGkkp = setNameLang(this.$i18n.locale, response[0]);
        } else {
            this.curGkkp = null;
        }

        this.chgGkkp();
        this.gkkpBase = response;
    }

    private loadAllTypePrg() {
        if (!this.curVariant || !this.curAbp || !this.curRegion) {
            this.prgBase = [setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { prg: null }))];
            this.curPrg = setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { prg: null }));
            return;
        }
        const params: any = { curYear: this.curYear, region: this.curRegion.code, abp: this.curAbp.abp, variant: this.curVariant.variant_uuid, date_b: this.curVariant.date_start, date_e: this.variantEndDate, gu: this.curGu? this.curGu.code: null, vers_year: this.versYear };
        let url = `/api-py/get-budget-sum-calc-upload-filter-prg/${encodeURI(JSON.stringify(params))}`;
        if (this.filterType !== 0 && this.tabIndxSelected === 3) {
            params.curGkkp = this.curGkkp ? this.curGkkp.bin: '-1';
            url = `/api-py/get-budget-sum-calc-upload-filter-prg-type-gkkp/${encodeURI(JSON.stringify(params))}`;
        }
        this.loadPrg(url);
    }

    private async loadPrg(url: string) {
        let response: any = [];
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка загрузки программ', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки программ', (error as Error).toString());
        }
        response.unshift(setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { prg: null })));
        this.curPrg = setNameLang(this.$i18n.locale, response[0]);
        this.prgBase = response;
    }

    private loadAllTypeSubordinate() {
        this.curSubord = null;
        this.subordBase = [];
        if (!this.curVariant || !this.curAbp || !this.curRegion || !this.usrId) {
            this.chgSubord();
            return;
        }
        const params = { abp: this.curAbp.abp, usrId: this.usrId, region: this.curRegion.code, date_b: this.curVariant.date_start, date_e: this.variantEndDate, vers_year: this.versYear, abpEnabled: this.abpEnabled };

        let url = `/api-py/get-budget-upload-subordinate/${encodeURI(JSON.stringify(params))}`;
        if (this.filterType !== 0) {
            url = `/api-py/get-budget-upload-subordinate-for-gkkp/${encodeURI(JSON.stringify(params))}`;
        }
        this.loadSubordinate(url);
    }

    // загрузку подведомственных
    private async loadSubordinate(url: string) {
        let result: any[] = [];
        try {
            const response: any = await fetch(url);
            if (response.status === 200) {
                result = await response.json();
                this.subordBase = result;
                if (this.subordBase.length) {
                    this.subordBase.sort((a, b) => (a.code > b.code) ? 1 : -1);
                    let curSubord = this.subordBase[0].code!==null ? this.subordBase[0]: this.subordBase[1];
                    if (this.tabIndxSelected === 1) { curSubord = setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { code: null })) }
                    this.curSubord = curSubord.code ? setNameLang(this.$i18n.locale, curSubord, 'code'): curSubord;
                }
            }  else {
                makeToast(this, 'danger', 'Ошибка загрузки подведомственных', `${response.status} ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки подведомственных', (error as Error).toString());
        } finally {
            this.chgSubord();
        }
    }

    private loadAllTypeGu() {
        if (!this.curVariant || !this.curAbp || !this.curRegion || !this.usrId) {
            this.guBase = [];
            return;
        }
        let curSubord = null;
        if (this.tabIndxSelected === 3 || this.tabIndxSelected === 1) {
            curSubord = this.curSubord? this.curSubord.code: '-1';
        }
        const params = { abp: this.curAbp.abp, usrId: this.usrId, region: this.curRegion.code, dateB: this.curVariant.date_start, dateE: this.variantEndDate, vers_year: this.versYear, abpEnabled: this.abpEnabled, subord: curSubord };
        let url = `/api-py/budget-total-get-gu/${encodeURI(JSON.stringify(params))}`;
        if (this.tabIndxSelected === 1) {
            url = `/api-py/budget-total-get-gu-for-svod-gu/${encodeURI(JSON.stringify(params))}`
        }
        if (this.filterType !== 0) {
            url = `/api-py/budget-total-get-gu-for-gkkp/${encodeURI(JSON.stringify(params))}`;
        }
        this.loadGu(url);
    }

    private async loadGu(url: string) {
        this.curGu = null;
        if (!this.curVariant || !this.curAbp || !this.curRegion || !this.usrId) {
            this.guBase = [];
            return;
        }
        let result: any = [];

        if (this.curAbp !== null) {
            try {
                result = await fetch(url);
                if (result.status === 200) {
                    result = await result.json();
                } else {
                    makeToast(this, 'danger', 'Ошибка загрузки гос. учреждений', `${result.status} - ${result.statusText}`);
                    this.curGu = null;
                    return;
                }
                if (result.length > 0) {
                    if (this.urlFilter && this.urlFilter.gu) {
                        this.curGu = setNameLang(this.findElByCode('code', this.urlFilter.gu, result), 'code');
                        this.urlFilter.gu = null;
                        // this.chgData();
                    } else {
                        if (this.tabIndxSelected === 1) {
                            this.curGu = setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { code: null }))
                        } else {
                            if (result[0].code === null && result.length > 1) {
                                this.curGu = setNameLang(this.$i18n.locale,  result[1], 'code');
                            } else {
                                this.curGu = setNameLang(this.$i18n.locale,  result[0]);
                            }
                        }
                    }
                }
                this.guBase = result;
            } catch (error) {
                this.guBase = [];
                this.curGu = null;
                makeToast(this, 'danger', 'Ошибка загрузки гос. учреждений', (error as Error).toString());
            } finally {
                this.chgGu();
            }
        }
    }

    private getTabIndx() {
        const oldTabIndxSelected = this.tabIndxSelected;
        const arr = [{name: 'abp', indx: 0}, {name: 'gu', indx: 1}, {name: 'gkkp', indx: 2}, {name: 'load', indx: 3}];
        for (let i = 0; i < arr.length; i++) {
            if (i < 0) { break; }
            if (!this.abpEnabled && arr[i].name === 'abp') {
                arr.splice(i, 1);
                i--;
            } else if (!this.guEnabled && arr[i].name === 'gu') {
                arr.splice(i, 1);
                i--;
            } else if (!this.gkkpEnabled && arr[i].name === 'gkkp') {
                arr.splice(i, 1);
                i--;
            } else if (!this.loadTabEnabled && arr[i].name === 'load') {
                arr.splice(i, 1);
                i--;
            }
        }
        if (this.tabIndx < 0) {
            this.tabIndxSelected = this.tabIndx;
        } else {
            this.tabIndxSelected = arr[this.tabIndx].indx;
        }
        // ----
        if (this.curSubord !== null) {
            const indx = this.subordBase.findIndex(group => group.code === this.curSubord.code);
            if (this.tabIndxSelected === 1) {
                this.curSubord = setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { code: null }));
            }
            if (indx < 0) {
                if (this.subordBase.length) {
                    let curSubord = this.subordBase[0].code!==null ? this.subordBase[0]: this.subordBase[1];
                    if (this.tabIndxSelected === 1) { curSubord = setNameLang(this.$i18n.locale, Object.assign(this.nameAllObj, { code: null })) }
                    this.curSubord = curSubord.code ? setNameLang(this.$i18n.locale, curSubord, 'code'): curSubord;
                } else {
                    this.curSubord = null;
                }
            }
        }
        // ---
        this.chgFilterType(oldTabIndxSelected);
    }

    private loadClk() {
        if (this.tabIndxSelected === 3) {
            const params: any = { curYear: this.curYear, curAbp: this.curAbp, curDataType: this.curDataType, regionProp: this.curRegion, curVariant: this.curVariant, curGu: this.curGu? this.curGu: {code: '-1'}, prg: this.curPrg.prg };
            params.isGkkp = (this.uploadFilterType === 1);
            params.guParent = this.curSubord? this.curSubord.code: null;
            if (this.uploadFilterType === 1) {
                params.gkkp = this.curGkkp? this.curGkkp.bin: null;
                params.isAddNeed = this.isAdditionalNeed
            } else {
                params.isAgregate = (this.inAbpGuSection === 1);
                params.isAddNeed = (this.inAbpGuSection === 2);
            }
            params.isConfirm = this.isConfirm
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refUpload.loadClk(params);
        }
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.drop.hide(true);
    }

    private guChgSignAcces(params: any) {
        this.guSignOperEnable = params.signOperEnable;
        this.guUserSignEnable = params.userSignEnable;
        this.guCurUserSigned = params.curUserSigned;
    }

    private abpChgSignAcces(params: any) {
        this.abpSignOperEnable = params.signOperEnable;
        this.abpUserSignEnable = params.userSignEnable;
        this.abpCurUserSigned = params.curUserSigned;
    }

    private startSignGu() {
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refGu.startSignClk();
    }

    private recalSignGu() {
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refGu.recalSignModal();
    }

    private logSignGu() {
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refGu.logSign();
    }

    private startSignAbp() {
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refAbp.startSignClk();
    }

    private recalSignAbp() {
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refAbp.recalSignModal();
    }

    private logSignAbp() {
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refAbp.logSign();
    }

    private chgAgrAccess(agrEnabledAccess: boolean) {
        this.agrEnabledAccess = agrEnabledAccess;
    }

    // изменение типа фильтра АБП или АБП(гккп)
    private chgFilterType(oldTabIndxSelected: null | number = null) {
        let filterType = 0;
        if (this.tabIndxSelected === 3) {
            filterType = this.uploadFilterType;
            if (this.uploadFilterType === 1) {
                    this.isAdditionalNeed = this.inAbpGuSection === 2
            } else {
                if (this.isAdditionalNeed)
                    this.inAbpGuSection=2
                else
                    this.inAbpGuSection = 0
            }
        }
        if (this.filterType!==filterType || (oldTabIndxSelected === 1 && this.tabIndxSelected === 3)) {
            // alert("change type")
            this.filterType = filterType;
            this.loadAllTypeAbp();
            return;
        }
        if (this.tabIndxSelected === 1 || this.tabIndxSelected === 2) {
            this.loadAllTypeGu();
        }
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get tabTitle() {
        const obj = {
            abp: this.getBudgetText('sum_calc_abp.title'), // Свод по АБП
            gu: this.getBudgetText('sum_calc_gu.title'), // Свод по ГУ
            gkkp: this.getBudgetText('sum_calc_gkkp.title'), // Свод по ГККП
            upload: this.getBudgetText('sum_calc_upload.title') // Пакетная выгрузка
        }
        return obj
    }

    private get filterTitle() {
        const obj = {
            title: this.getBudgetText('filter.filter'), // Фильтр
            filterPrm: this.getBudgetText('filter.params'), // Параметры фильтра
            curYear: this.getBudgetText('filter.curYear'), // Плановый период
            region: this.getBudgetText('filter.region'), // Регион
            dataType: this.getBudgetText('filter.dataType'), // Вид данных
            variant: this.getBudgetText('filter.variant'), // Версия бюджета
            abp: this.getBudgetText('filter.abp'), // Адм. программ
            subord: this.getBudgetText('filter.subord'), // Подведомственные
            gu: this.getBudgetText('filter.gu'), // Гос. учреждение
            gkkp: this.getBudgetText('filter.gkkp'), // Казенное предприятие
            prg: this.getBudgetText('filter.prg'), // Программа
            gkkpType: {
                'type0': this.getBudgetText('filter.gkkpType.type0'), //  без уч.платных
                'type1': this.getBudgetText('filter.gkkpType.type1') // с уч. платных
            },
            inAbpGuSection: {
                "val0": this.getBudgetText('filter.inAbpGuSection.val0'), //  В разрезе ГУ
                'val1': this.getBudgetText('filter.inAbpGuSection.val1'), // Агрег. данные
                'val2': this.getBudgetText('filter.inAbpGuSection.val2') // Доп потребность
            },
            isConfirm: this.getBudgetText('filter.isConfirm'),
            uploadType: {
                "val0": this.getBudgetText('filter.uploadType.val0'), //  АБП/ГУ
                "val1": this.getBudgetText('filter.uploadType.val1'), //  ГККП
            },
            bread: {
                "val0": this.getBudgetText('filter.bread.val0'), //  -регион
                "val1": this.getBudgetText('filter.bread.val1'), //  -версия
                "val2": this.getBudgetText('filter.bread.val2'), //  -АБП
                "val3": this.getBudgetText('filter.bread.val3'), //  ВСЕ-ГУ
                "val4": this.getBudgetText('filter.bread.val4'), //  ВСЕ-ГККП
                "val5": this.getBudgetText('filter.bread.val5'), //  -ГККП
            }
        }
        return obj;
    }

    private get buttonTitle() {
        const obj = {
            signEcp: this.getBudgetText('button.sign_ecp'), // Подписать ЭЦП
            logSign: this.getBudgetText('button.log_sign'), // Журнал ЭЦП
            agrEvent: this.getBudgetText('button.agr_event'), // Действия
            download: this.getBudgetText('button.download'), // Скачать
            recalSign: this.getBudgetText('button.recalSign'), // Отозвать ЭЦП
            loadFavorit: this.getBudgetText('button.loadFavorit'), // Загрузка Фаворит
            loadClk: this.getBudgetText('button.loadClk'), // Загрузить
        }
        return obj
    }

    private get otherTitle() {
        const obj = {
            mainTitle: this.getBudgetText('other.mainTitle'), // Бюджетное планирование
            subTitle: this.getBudgetText('other.subTitle'), // Бюджетные заявки
            infoBtn: this.getBudgetText('other.infoBtn'), // Режим «Свод по АБП/ГУ
            video_instruction: this.getBudgetText('other.video_instruction'), // Видеоинструкция
            infoTextTitle: this.getBudgetText('other.infoTextTitle'), // Раздел «Свод по АБП/ГУ
            infoText: this.getBudgetText('other.infoText'), // Данный раздел содержит сводную информацию расчета расходов Администратора бюджетных программ (далее АБП) по ГУ, БП, БПП, согласно приказа №511 МФ РК «Об утверждении правил составления и представления бюджетной заявки».
            reportAbp: this.getBudgetText('other.reportAbp'), // Сводный расчет расходов АБП
            reportAbpGkkp: this.getBudgetText('other.reportAbpGkkp'), // Сводный расчет расходов АБП с учетом данных ГККП
            reportGu: this.getBudgetText('other.reportGu'), // Сводный расчет расходов АБП по ГУ
            reportCalcGu: {
                val0: this.getBudgetText('other.reportCalcGu.val0'), // Сводный расчет расходов
                val1: this.getBudgetText('other.reportCalcGu.val1'), // АБП по подведомственным ГУ
            },
            btnDownload2: {
                val0: this.getBudgetText('other.btnDownload2.val0'), // Свод ГККП (без учета платных)
                val1: this.getBudgetText('other.btnDownload2.val1'), // Свод ГККП (с учетом платных)
                val2: this.getBudgetText('other.btnDownload2.val2'), // Сводный расчет расходов по ГККП
            },
            confirm_favorit: this.getBudgetText('other.confirm_favorit'), // Загрузить данные из ИС Фаворит?
            confirm: this.getBudgetText('other.confirm'), // Подтверждение
            conf_yes: this.getBudgetText('other.conf_yes'), // Да
            conf_no: this.getBudgetText('other.conf_no'), // Нет
            importFavorit: [
                this.getBudgetText('other.importFavorit[0]'), // Вид загружаемых данных
                this.getBudgetText('other.importFavorit[1]'), // не совпадает с видом данных актуальной версии бюджета. Продолжить импорт?
            ]
        }
        return obj;
    }

    private get dynamicAppendixTitles() {
        const lang = this.$i18n.locale;
        const suffix = lang === 'kk' ? ' (МҚКК жиынтығы)' : ' (Свод ГККП)';

        const formatTitle = (num: number | null) => {
            if (!num) {
                return (lang === 'kk' ? 'Қосымша' : 'Приложение') + suffix;
            }
            return lang === 'kk'
                ? `${num} - қосымша${suffix}`
                : `Приложение ${num}${suffix}`;
        };

        return {
            app49: formatTitle(this.appendixNumbers['02-159']),
            app58: formatTitle(this.appendixNumbers['Form_GU_svod']),
            app67: formatTitle(this.appendixNumbers['01-311_svod'])
        };
    }

    private timerId: number | null = null;
    private readonly targetDate: Date = new Date('2026-06-19T23:59:00');

    beforeDestroy(): void {
        if (this.timerId !== null) {
            window.clearInterval(this.timerId);
        }
    }

    getCountdownText(): string {
        const lang = this.$i18n.locale;
        const now = new Date();
        const diff = this.targetDate.getTime() - now.getTime();

        const totalHours = Math.max(0, Math.floor(diff / (1000 * 60 * 60)));
        const days = Math.floor(totalHours / 24);
        const hours = totalHours % 24;

        if (lang === 'ru') {
            return `До сдачи Прогноза 2027–2029 осталось ${days} дн, ${hours} ч`;
        }

        if (lang === 'kk') {
            return `Болжам 2027–2029 тапсыруға ${days} күн, ${hours} сағат қалды`;
        }

        return `There are ${days} days and ${hours} hours left until submitting BS 2027–2029`;
    }
    // -------------
}
